var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhatsApp = function SvgWhatsApp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.987,
    x2: 0.5,
    y2: -0.013,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61fd7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2bb826"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsapp-icon-seeklogo",
    transform: "translate(-390 -391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(390 391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M411.978,407.4c0,.121,0,.381-.011.583a11.573,11.573,0,0,1-.116,1.42,4.739,4.739,0,0,1-.4,1.189,4.237,4.237,0,0,1-1.865,1.863,4.727,4.727,0,0,1-1.2.4,11.62,11.62,0,0,1-1.409.114c-.2.007-.463.011-.583.011l-10.822,0c-.121,0-.381,0-.583-.011a11.56,11.56,0,0,1-1.42-.116,4.739,4.739,0,0,1-1.189-.4,4.237,4.237,0,0,1-1.863-1.865,4.726,4.726,0,0,1-.4-1.2,11.625,11.625,0,0,1-.114-1.409c-.007-.2-.011-.463-.011-.583l0-10.822c0-.121,0-.381.011-.583a11.564,11.564,0,0,1,.116-1.42,4.741,4.741,0,0,1,.4-1.189,4.237,4.237,0,0,1,1.865-1.863,4.728,4.728,0,0,1,1.2-.4,11.632,11.632,0,0,1,1.409-.114c.2-.007.463-.011.583-.011l10.822,0c.121,0,.381,0,.583.011a11.562,11.562,0,0,1,1.42.116,4.739,4.739,0,0,1,1.189.4,4.237,4.237,0,0,1,1.863,1.865,4.726,4.726,0,0,1,.4,1.2,11.638,11.638,0,0,1,.114,1.409c.007.2.011.463.011.583Z",
    transform: "translate(-390 -391)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(393.292 393.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M440.061,425.4a7.881,7.881,0,0,0-12.4,9.506l-1.118,4.083,4.178-1.1a7.868,7.868,0,0,0,3.767.959h0a7.88,7.88,0,0,0,5.573-13.452Zm-5.575,12.122h0a6.548,6.548,0,0,1-3.334-.913l-.24-.142-2.479.65.662-2.416-.156-.248a6.551,6.551,0,1,1,5.549,3.068Zm3.594-4.9c-.2-.1-1.165-.575-1.346-.641s-.312-.1-.443.1-.509.641-.623.772-.23.148-.427.05a5.361,5.361,0,0,1-1.584-.977,5.9,5.9,0,0,1-1.1-1.364c-.114-.2-.013-.3.086-.4s.2-.23.3-.345a1.362,1.362,0,0,0,.2-.329.364.364,0,0,0-.016-.345c-.05-.1-.443-1.068-.607-1.462s-.323-.331-.443-.338-.246-.007-.377-.007a.725.725,0,0,0-.525.246,2.208,2.208,0,0,0-.689,1.642,3.824,3.824,0,0,0,.8,2.037,8.774,8.774,0,0,0,3.364,2.973,11.175,11.175,0,0,0,1.122.414,2.709,2.709,0,0,0,1.241.078,2.029,2.029,0,0,0,1.329-.936,1.653,1.653,0,0,0,.115-.936C438.408,432.766,438.277,432.717,438.08,432.618Z",
    transform: "translate(-426.54 -423.09)",
    fill: "#fff"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsApp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsApp.927b02f8.svg";
export { ForwardRef as ReactComponent };